var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_svg__cloud_upload_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 147.04,
    y1: 189.64,
    x2: 283.97,
    y2: 189.64,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upload_svg__cloud_upload_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 153.04,
    y1: 189.64,
    x2: 277.97,
    y2: 189.64,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%, 56.470588%, 100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%, 83.137255%, 94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "upload_svg__cloud_upload_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 7.058594 26.875 C 6.007812 26.875 5.015625 26.464844 4.273438 25.71875 C 3.527344 24.972656 3.117188 23.980469 3.121094 22.929688 L 3.125 19.601562 C 3.125 19.066406 3.558594 18.632812 4.09375 18.632812 C 4.628906 18.632812 5.058594 19.070312 5.058594 19.601562 L 5.054688 22.929688 C 5.054688 23.46875 5.261719 23.972656 5.640625 24.351562 C 6.019531 24.730469 6.523438 24.9375 7.058594 24.9375 L 24.929688 24.9375 C 26.039062 24.9375 26.941406 24.039062 26.941406 22.929688 L 26.945312 19.726562 C 26.945312 19.191406 27.378906 18.757812 27.914062 18.757812 C 28.171875 18.757812 28.414062 18.859375 28.597656 19.042969 C 28.78125 19.226562 28.882812 19.46875 28.882812 19.726562 L 28.875 22.929688 C 28.875 25.105469 27.101562 26.875 24.929688 26.875 Z M 7.058594 26.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%, 96.862745%, 96.862745%)",
      fillOpacity: 1
    },
    d: "M 24.929688 26.429688 L 7.058594 26.429688 C 6.125 26.429688 5.246094 26.0625 4.585938 25.402344 C 3.925781 24.742188 3.5625 23.863281 3.566406 22.929688 L 3.570312 19.601562 C 3.570312 19.3125 3.804688 19.082031 4.089844 19.082031 L 4.09375 19.082031 C 4.378906 19.082031 4.613281 19.3125 4.613281 19.601562 L 4.605469 22.929688 C 4.605469 23.585938 4.859375 24.203125 5.324219 24.667969 C 5.785156 25.128906 6.402344 25.386719 7.058594 25.386719 L 24.929688 25.386719 C 26.28125 25.386719 27.386719 24.285156 27.386719 22.929688 L 27.390625 19.726562 C 27.390625 19.4375 27.625 19.207031 27.914062 19.207031 C 28.199219 19.207031 28.433594 19.4375 28.433594 19.726562 L 28.429688 22.929688 C 28.425781 24.859375 26.855469 26.425781 24.925781 26.425781 Z M 24.929688 26.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#upload_svg__cloud_upload_svg__linear0)"
    },
    d: "M 16.046875 23.070312 C 15.53125 23.070312 15.109375 22.648438 15.109375 22.132812 L 15.109375 8.363281 L 12.542969 10.925781 C 12.367188 11.101562 12.132812 11.203125 11.882812 11.203125 C 11.628906 11.203125 11.394531 11.105469 11.21875 10.925781 C 11.039062 10.75 10.941406 10.511719 10.941406 10.261719 C 10.941406 10.011719 11.039062 9.777344 11.21875 9.597656 L 15.386719 5.429688 C 15.5625 5.253906 15.800781 5.152344 16.050781 5.152344 C 16.300781 5.152344 16.539062 5.25 16.714844 5.429688 L 20.855469 9.574219 C 21.222656 9.9375 21.222656 10.535156 20.855469 10.902344 C 20.679688 11.078125 20.445312 11.175781 20.195312 11.175781 C 19.941406 11.175781 19.707031 11.078125 19.53125 10.902344 L 16.988281 8.359375 L 16.988281 22.132812 C 16.988281 22.652344 16.566406 23.070312 16.050781 23.070312 Z M 16.046875 23.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#upload_svg__cloud_upload_svg__linear1)"
    },
    d: "M 16.046875 22.625 C 15.777344 22.625 15.554688 22.40625 15.554688 22.132812 L 15.554688 7.285156 L 12.230469 10.609375 C 12.035156 10.804688 11.726562 10.804688 11.53125 10.609375 C 11.339844 10.417969 11.339844 10.105469 11.53125 9.914062 L 15.703125 5.746094 C 15.792969 5.652344 15.917969 5.601562 16.050781 5.601562 C 16.179688 5.601562 16.304688 5.652344 16.398438 5.746094 L 20.542969 9.890625 C 20.734375 10.082031 20.734375 10.394531 20.542969 10.585938 C 20.347656 10.777344 20.035156 10.777344 19.84375 10.585938 L 16.539062 7.28125 L 16.539062 22.132812 C 16.539062 22.40625 16.320312 22.625 16.046875 22.625 Z M 16.046875 22.625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f66eea2dbe565b30eec23cb1f01ce12a.svg";
export { ForwardRef as ReactComponent };